<template>
	<div id="cart">
		<div id="content" class="content cart">
			<div class="container">
				<!-- 페이지 타이틀 -->
				<div class="page-title">
					<h2 class="tit">장바구니</h2>
				</div>
				<div class="cart-list" v-if="cartVOLength > 0">
					<div class="row-box" v-for="(item, index) in cartVOList" :key="index">


						<!-- 체크박스-->
						<div class="chk-box" v-if="item.goodsVO.selling && item.goodsVO.stock">
							<label class="chkBox">
								<input type="checkbox" :id="'chkBox' + item.cidx" :value="item.cidx" v-model="chkIdxs" @change="calcTotalCost()" :readonly="item.count < 1">
								<span class="chkIcon"></span>
							</label>
						</div>

						<!-- 썸네일 -->
						<div class="product-thumb">
							<img class="thumb-box" v-if="item.goodsVO.thumbIdx !== null" :src="APIs.SHOP_FILE_SHOW + item.goodsVO.thumbIdx"/>
							<img class="thumb-box" v-else src="public/assets/img/common/img_thumb.svg"/>
						</div>

						<!-- 상품명 + 선택 옵션 -->
						<div class="product-name">
							<a :href='"/app/shop/goods/"+item.gid'>{{ item.goodsVO.title }}</a>
							<div class="product-option-summary" v-if="item.optionSummary">{{ item.optionSummary }}</div>
							<br><span class="unit" v-show="item.goodsVO.isVat">*부가세포함</span>
						</div>

						<!-- 판매상태 +  재고O -->
						<template v-if="item.goodsVO.selling && item.goodsVO.stock">
							<!-- 상품가격 -->
							<div class="product-quantity" style="padding:0 24px 0 0; !important;">
								<span class="btns-added"></span>
								<input type="button" value="-" class="btn-minus m-b-15" @click="updateCart(cartVOList[index].count > 1 ? --cartVOList[index].count : cartVOList[index].count, cartVOList[index].cidx)">
								<label class="blind" for="quantity">수량</label>
								<!-- 0또는 자연수만 입력 가능하도록 설정 -->
								<input type="number" class="inp-qty" id="quantity" name="quantity" title="수량" size="4" oninput="this.value = this.value.replaceAll(/\D/g, '');" step="1" v-model="cartVOList[index].count" @change="updateCart(cartVOList[index].count, cartVOList[index].cidx)">
								<input type="button" value="+" class="btn-plus  m-b-15" @click="updateCart(++cartVOList[index].count,  cartVOList[index].cidx)">
							</div>
							<div class="product-price p-r-15" >
								{{ (item.goodsVO.basePrice + (item.optionPriceSum || 0)) * cartVOList[index].count | currency }}<span class="unit"> 원</span>
							</div>
						</template>

						<!-- 판매중지 +  재고X -->
						<template v-else>
							<div class="product-name" v-if="!item.goodsVO.selling">판매중지된 상품입니다.</div>
							<div class="product-name" v-if="!item.goodsVO.stock">재고가 없습니다.</div>
						</template>

						<!-- 삭제-->
						<div class="product-remove">
							<a class="btn-remove" @click="deleteItem(item.cidx)"><span class="blind">제거</span></a>
						</div>

					</div>
				</div>
				<div class="label" v-else>
					<div class="payment-done">
						<p class="guide">장바구니에 상품이 존재하지 않습니다.</p>
					</div>
				</div>
				<!-- 총합-->
				<div class="cart-total" v-if="cartVOLength > 0">
					<span class="label">총 상품 금액</span>
					<span class="price">{{ totalCost | currency }}<span class="unit">원</span></span>
				</div>

				<div class="btn-area">
					<button type="button" class="btn-submit" @click="doPurchase" v-if="totalCost > 0">결제 진행하기</button>
					<button type="button" class="btn-submit" v-else style="background-color: silver" disabled>결제 진행하기
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	name: "cartList",
	data() {
		var params = this.pageUtils.Params()
		return {
			params,
			cartVOList: [],
			cartVOLength: 0,
			totalCost: 0,

			chkIdxs: [],
			cartVO: new this.CartVO(this.getSessionProc()),
		}
	},
	async created() {
		if(!this.isLogin())
			await !this.requireLogin(this, false)
		this.getCart();
		// 페이지 뒤로가기 감지 후 새로고침 (임시)
		window.onpageshow = function (e) {
			if (e.persisted || (window.performance && window.performance.navigation.type === 2)) {
				for (var i = 0; i < localStorage.length; i++) {
					$('.inp-qty').eq(i).val(localStorage.getItem(`${i}`))
					localStorage.removeItem(`${i}`)
				}
			}
		}
	},
	methods: {
		// 장바구니 데이터 받아오는 method
		getCart() {
			this.axiosCaller.get(this, this.APIs.CART + "/getMyCart", {
				userId: this.getSessionProc().coEmailId
			}, (res) => {
				console.log(res.data)
				var result = res.data.cartList;
				this.cartVOList = result;
				this.cartVOLength = result.length;

				this.$nextTick(() => {
					this.allChks(this.cartVOList)
				})
			});
		},
		// "결제 진행하기" btn method
		doPurchase() {
			for (var i = 0; i < this.cartVOList.length; i++) {
				localStorage.setItem(`${i}`, this.cartVOList[i].count)
			}
			// "idx"  : self.chkIdxs.join(',')
			console.log('chkIdx', this.chkIdxs)
			this.$router.push({
				query: this.params,
			}).catch(() => {})
			location.href ="/app/shop/order_info?cidxs="+this.chkIdxs;
		},
		// 총액 계산
		calcTotalCost() {

			var cartVOList = this.cartVOList
			var totalAmount = 0;

			this.chkIdxs.forEach(function (idxs){
				cartVOList.forEach(function (cartVO) {
					if (cartVO.cidx === idxs) {
						var optionSum = cartVO.optionPriceSum || 0
						var eachAmount = (cartVO.goodsVO.basePrice + optionSum) * cartVO.count

						/**
						 * 판매성태 + 재고있는 상품만 계산
						 */
						if ( cartVO.goodsVO.selling && cartVO.goodsVO.stock ) {
							totalAmount += eachAmount
						}
					}
				})
			})
			this.totalCost = totalAmount;

			console.log('chkIdxs',this.chkIdxs)
		},
		// 상품 삭제
		deleteItem(cidx) {

			this.spliceArr(this.chkIdxs,cidx)

			this.axiosCaller.delete(this, this.APIs.CART + "/deleteMyCart/" + cidx, {}, (res) => {
				console.log(res)
				if (res.data.status === "ok") {
					this.swalUtils.gritter("삭제완료", "장바구니에서 삭제되었습니다.", "success")
					this.getCart()
					this.calcTotalCost()
				} else {
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
		},
		//상품 개수 변동시 CartVO.count update
		updateCart(count, idx) {
			this.cartVO.count = count;
			this.cartVO.cidx = idx;

			this.axiosCaller.patch(this, this.APIs.CART + "/updateMyCart", this.cartVO, (res) => {
				if (res.data.status === "fail") {
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
			this.calcTotalCost()
		},
		goView(_idx) {
			// 기존 게시물 삭제
			this.resetBoardOne();
			this.params.idx = _idx
			console.log( this.params )
			// this.pageUtils.pushState( this.params )
			this.$router.push({
				query: this.params,
			}).catch(() => {})
			this.getBoardOne();
		},
		allChks(cartVOList) {
			var chkIdxs = []
			// var cartVOList = this.cartVOList

			console.log('cartVOList',cartVOList)

			for (var i = 0 ; i < cartVOList.length ; i++) {

				if ( cartVOList[i].goodsVO.selling && cartVOList[i].goodsVO.stock ) {
					chkIdxs.push(cartVOList[i].cidx);
				}
			}
			this.chkIdxs = chkIdxs;
		},
		//삭제시 chkIdxs에서도 제외
		spliceArr(arr,value) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] === value) {
					arr.splice(i, 1);
					i--;
				}
			}
		},
	},
	watch: {
		'chkIdxs': function (val) {
			console.log(val)
			this.calcTotalCost()
		}

	}
}

</script>

<style scoped>
.chk-box {
	width: 5%;
}
.chkBox input {
	display: none;
}
.chkIcon {
	border-radius: 50%;
	display: inline-block;
	/* 체크 박스 사이즈 */
	width: 28px;
	height: 28px;
	background-color: transparent;
	/* 체크 해제 시 테두리 색, 체크 해제, 체크 시 두께 */
	border: 1pt solid #f0f0f0;
	position: relative;
	cursor: pointer;
}
.chkIcon::before,
.chkIcon::after {
	content: '';
	display: inline-block;
	/* 체크 표시 두께 */
	width: 2px;
	height: 0;
	/* 체크 표시 색 */
	background-color: #000000;
	position: absolute;
	transform-origin: left top;
}
.chkIcon::before {
	/* 체크 표시 1 위치 */
	top: 13px;
	left: 7px;
	transform: rotate(-45deg);
}
.chkIcon::after {
	/* 체크 표시 2 위치 */
	top: 18px;
	left: 12px;
	transform: rotate(-135deg);
}
.chkBox input:checked + .chkIcon {
	/* 체크 시 테두리 색 */
	border-color: #f0f0f0;
}
/* 체크 진행 1 */
.chkBox input:checked + .chkIcon::before {
	/* 체크 표시 1 길이 */
	height: 7px;
	transition: all 0.1s ease;
}
/* 체크 진행 2 */
.chkBox input:checked + .chkIcon::after {
	/* 체크 표시 2 길이 */
	height: 11px;
	transition: all 0.1s ease 0.1s;
}
/* 체크 해제 진행 1 */
.chkBox input + .chkIcon::after {
	height: 0;
	transition: all 0.1s ease;
}
/* 체크 해제 진행 2 */
.chkBox input + .chkIcon::before {
	height: 0;
	transition: all 0.1s ease 0.1s;
}
/* 선택 옵션 표시 (상품명 밑) */
.product-option-summary {
	font-size: 13px;
	color: #666;
	margin-top: 4px;
	line-height: 1.4;
}
/* input type number arrow 비활성화 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
</style>
